import SingleDigitalGateway from './SingleDigitalGateway';

export default SingleDigitalGateway;
